import { openModal } from '../actions';
import { optionsData } from './types';

export const openOptionsConfirmationModal = (
  data: optionsData,
  onClose?: () => any,
) => openModal('OPTIONS_CONFIRMATION', { data });
